import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { logout, setCredentials } from './authSlice';

interface IdsState {
  id: string;
  isLoading: boolean;
}

const initialState: IdsState = {
  id: '',
  isLoading: false,
};

const selectedJobId = createSlice({
  name: "selectedJobId",
  initialState,
  reducers: {
    setSelectedJobId: (state, action: PayloadAction<{ id: string }>) => {
      state.id = action.payload.id;
      state.isLoading = false;
    },

    setSelectedJobLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    clearSelectedJobId: (state) => {
      state.id = '';
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(setCredentials, () => initialState);
  },
});

export const { setSelectedJobId, setSelectedJobLoading, clearSelectedJobId } =
  selectedJobId.actions;

export default selectedJobId.reducer;
